import { createBrowserRouter } from "react-router-dom";
import { exchangeOAuth, fetchBillPrivileges, getBillEntryPreferences, getCorporations, getPrivileges, login, userApprovals } from "../API/nimble";
import Dcp from "../Pages/DcpImport/Dcp";

const billPrivileges = {
  BillEntry: "010000000000000000000000000000000370",
  BillPayment: "010000000000000000000000000000000371"
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <Dcp />,
    loader: async ({ request }) => {
      try {
        const url = new URL(request.url);
        const urlInfo = url.searchParams.get("UrlInfo");
        const authId = url.searchParams.get("AuthID");
        const menuID = url.searchParams.get("MenuID");
        const headerCrpId = url.searchParams.get("corpid");
        // const authId = await login(
        //   "Master@nimbleproperty.net",
        //   "kPhp@300",
          // "ajay@nimbleaccounting.com",
          // "Ajay@123",
        //   "naveen.panchakarla@nimbleaccounting.com",
        //   "Naveen@123",
        //   "qa8"
        // );

    

        const data = await exchangeOAuth(authId);
      
        const token = data.token;
     
        const currentDate = data.curServerDateTime;
     

      
        const userName = data.userName;
        const privileges = await getPrivileges(menuID, token); 
      //  const privileges = { Create: true ,View: false};
        const getBillPrivileges = await fetchBillPrivileges(menuID, billPrivileges, token) 
        const preferences = await getBillEntryPreferences(menuID, token)

        const transactionType = 148;
  
        const getUserApprovalType = await userApprovals(transactionType,token);

        const setSelect = preferences.isLegalName ? { ID: "select", LegalName: "-Select-" ,AccountTypeName:"" } : { ID: "select", Name: "-Select-",AccountTypeName:"" };

        if (!token || !authId || !urlInfo || !menuID || !headerCrpId || !privileges || !preferences || !getUserApprovalType || !getBillPrivileges) {
          throw new Response("Missing required params", { status: 400 });
        }

        const corporations = await getCorporations(setSelect, token);

        
        return { token, corporations, userName, authId, urlInfo, menuID, headerCrpId, privileges, preferences, getUserApprovalType, billPrivileges, getBillPrivileges, setSelect,currentDate };
      } catch (err) {
        throw err; // rethrow so React Router knows
      }
    },
  },
]);

export default router;
